/**
 *  【配送单评价】入口页
 * */
import React from 'react';
import PropTypes from 'prop-types';
import Main from './pages/main';

const DeliveryOrder = ({ history, match }) => {
    return <Main history={history} match={match} />;
};

DeliveryOrder.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
};

export default DeliveryOrder;